module.exports = __webpack_public_path__ + "static/media/5000_Racoons.55030996.webp";